import {h, Fragment} from "preact"
import { useState } from "preact/hooks";
import { SerpElement, useCurrencyFormatting } from "@nosto/preact";
import { productImagePlaceholder } from "../helpers";

export default function ProductPlaceholder() {
  return (
    <li id="product-placeholder" className="grid__item flex flex-col gap-12 animate-pulse">
      <div
        className=""
      >
        <div
          className="relative overflow-hidden aspect-2-3 mb-8 lg:mb-12 bg-image animate-pulse bg-cover bg-center"
        >
          <div class="absolute inset-0 w-full h-full object-cover object-center bg-image animate-pulse flex justify-center items-center">
          <svg width="45" height="14" viewBox="0 0 45 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M32.7826 10.6401C32.4597 10.3031 32.2983 9.8188 32.2983 9.18905L32.2947 8.7367V0.0141916L12.1604 0V8.7367L12.1462 9.19083C12.1462 9.82058 11.9848 10.3031 11.6619 10.6419C11.3373 10.979 10.853 11.1493 10.2055 11.1493H9.87557H0V14H16.0418C18.9617 14 19.3804 12.8806 19.3804 10.4432V2.91105H25.0748V10.4415C25.0748 12.8789 25.4934 13.9982 28.4133 13.9982H44.4551V11.1475H34.2372C33.5897 11.1475 33.1054 10.979 32.7808 10.6419" fill="black"></path>
          </svg>
          </div>
        </div>

        <div className="flex justify-between gap-8 flex-col">
            <div className="flex flex-col justify-between gap-4 text-13-120 w-full">
                <h3 className="lg:col-span-6 normal-case bg-image animate-pulse placeholder-h-title w-full placeholder-title-height"></h3>
                <div aria-label="Price" class="price__sale flex gap-8 text-13-120 ">
                  <span class="bg-image animate-pulse placeholder-h-title w-full placeholder-title-height"></span>
                </div>
            </div>
        </div>
      </div>
    </li>
  );
}
